import dashboard from "@shared/services/tour/dashboard.ts";
import billing from "@shared/services/tour/billing.ts";
import security from "@shared/services/tour/security.ts";
import topology from "@shared/services/tour/topology.ts";
import settings from "@shared/services/tour/settings.ts";
import supportContacts from "@shared/services/tour/support-contacts.ts";
import supportTickets from "@shared/services/tour/support-tickets.ts";
import user from "@shared/services/tour/user.ts";
import notificationsCenter from "@shared/services/tour/notifications-center.ts";
import usageExposer from "@shared/services/tour/usageExposer.ts";
import usageExplorer from "@shared/services/tour/usageExplorer.ts";
import eventLogger from "@shared/services/tour/event-logger.ts";
import userProfile from "@shared/services/tour/user-profile.ts";
import manageUsers from "@shared/services/tour/manage-users.ts";
import impactCenter from "@shared/services/tour/impact-center.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";

export const MY_JFROG_APIS: TourUrlMapping = {
  ...billing,
  ...dashboard,
  ...usageExposer,
  ...topology,
  ...security,
  ...settings,
  ...supportContacts,
  ...supportTickets,
  ...user,
  ...notificationsCenter,
  ...usageExplorer,
  ...eventLogger,
  ...userProfile,
  ...manageUsers,
  ...impactCenter,
};
